var exports = {
  "dI": "ListItemTitle_Truncated__prkoeT",
  "az": "Box__Zgf4km",
  "wy": "Box_1__jmZZ_T",
  "m4": "Octicon__F8xOHb",
  "DZ": "Heading__LEw6uJ",
};

module.exports = exports;
